import { toKeyframeValue } from '../../utils';
const BLUR_POWER_MAP = {
  soft: 6,
  medium: 25,
  hard: 50
};
export function getNames(_) {
  return ['motion-fadeIn', 'motion-blurIn'];
}
export function web(options) {
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    blur = 6,
    power
  } = options.namedEffect;
  const [fadeIn, blurIn] = getNames(options);
  const easing = options.easing || 'linear';
  const blurFactor = power && BLUR_POWER_MAP[power] ? BLUR_POWER_MAP[power] : blur;
  const custom = {
    '--motion-blur': `${blurFactor}px`
  };
  return [{
    ...options,
    name: fadeIn,
    duration: options.duration * 0.7,
    easing: 'sineIn',
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    name: blurIn,
    easing,
    composite: 'add',
    // make sure we don't override existing filters on the component
    custom,
    keyframes: [{
      filter: `blur(${toKeyframeValue(custom, '--motion-blur', asWeb)})`
    }, {
      filter: 'blur(0px)'
    }]
  }];
}
//# sourceMappingURL=BlurIn.js.map